<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Kết quả thi học viên : {{ modelData.user_txt }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div v-if="modelData.id">
        <test-result-index :user_id="modelData.user_id"></test-result-index>
      </div>
      <h2>Thông tin về khóa học:</h2>
      <div class="model-content">
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :span="9" v-if="modelData.course.data">
              <el-form label-position="left" :model="modelData.course.data" ref="createModel" label-width="160px">
                <el-form-item prop="name" label="Tên khóa học :" class="form-item">
                  <span>{{ modelData.course.data.name }}</span>
                </el-form-item>
                <el-form-item prop="category_course_id" label="Lĩnh vực khóa học :" class="form-item">
                  <span>{{ modelData.course.data.category_course_text }}</span>
                </el-form-item>
                <el-form-item prop="teacher_id" label="Giảng viên" class="form-item">
                  <span>{{ modelData.course.data.teacher_txt }}</span>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="15">
              <el-form label-position="top" :model="modelData.course.data" ref="createModel">
                <img v-if="modelData.course.data.image_path" :src="modelData.course.data.image_path" class="course">
              </el-form>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import TestResultIndex from '@/components/test-results/Index'
export default {
  name: 'CourseShow',
  metaInfo () {
    return {
      title: 'Danh sách học'
    }
  },
  components: {
    TestResultIndex
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        id: 0,
        name: '',
        category_course_id: '',
        teacher_id: '',
        image: '',
        image_path: '',
        price: '',
        content: '',
        sale: '',
        date_start: '',
        date_end: '',
        course: {
          data: {
            name: '',
            category_course_text: '',
            teacher_txt: '',
            image_path: ''
          }
        },
        status: true
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'bookings-index', text: 'Danh sách học' },
        { name: 'bookings-create', text: 'Kết quả thi' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'bookings-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('bookings/' + this.$route.params.course_id, {params: {'include': 'course'}}).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.course {
  width: 280px;
  height: 200px;
  display: block;
}
</style>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/bookings/Show.vue